<template>
	<div class="relative inline-block">
		<span @click="toggleConfirmation">
			<slot />
		</span>
		<transition mode="out-in" :name="isConfirmationVisible ? 'slide-right' : 'slide-left'">
			<div v-if="isConfirmationVisible" class="app-confirmation-wrapper" :class="`${placement}`">
				<div class="absolute border-2 border-primary transition ease-in-out" :style="`width: ${barWidth}%`" />
				<div class="app-confirmation-content">
					<div class="flex flex-col">
						<p class="my-1">{{ title }}</p>
						<div class="flex flex-row">
							<app-button
								class="btn btn-success transparent small flex-1 mr-1"
								@click="confirm"
								icon="save"
							/>
							<app-button
								class="btn btn-warning transparent small flex-1 ml-1"
								@click="cancel"
								icon="cancel"
							/>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	export default {
		name: 'AppConfirmation',
		emits: ['confirm', 'cancel'],
		props: {
			title: {
				type: String,
				required: true,
			},
			placement: {
				type: String,
				required: false,
			},
			timeout: {
				type: Number,
				default: 3000,
			},
		},
		data() {
			return {
				isConfirmationVisible: false,
				barWidth: 0,
				interval: null,
				timeoutProp: null,
			};
		},
		methods: {
			startTimer() {
				const step = 10;
				if (!this.interval) {
					this.interval = setInterval(() => {
						this.barWidth = this.barWidth + (100 * step) / this.timeout;
					}, step);
				}
			},
			toggleConfirmation() {
				this.isConfirmationVisible = !this.isConfirmationVisible;
				if (this.isConfirmationVisible && this.timeout > 0) {
					this.startTimer();
					this.timeoutProp = setTimeout(() => {
						this.clearProgressBar();
					}, this.timeout);
				} else {
					this.clearProgressBar();
				}
			},
			clearProgressBar() {
				clearInterval(this.interval);
				clearTimeout(this.timeoutProp);
				this.interval = null;
				this.timeoutProp = null;
				this.isConfirmationVisible = false;
				this.barWidth = 0;
			},
			confirm() {
				this.clearProgressBar();
				this.$emit('confirm');
			},
			cancel() {
				this.clearProgressBar();
				this.$emit('cancel');
			},
		},
	};
</script>
